/**
 * MetricCards — coluna vertical de cards de métrica (total do período) que fica
 * sobre o mapa. Clicar num card troca a métrica que o mapa e os widgets mostram.
 *
 * `values` = { [metricKey]: number | null }; null/undefined mostram "—".
 * `inline`: fora do mapa (grade de 2 colunas num painel), em vez de sobreposta.
 * `list`: com `inline`, uma métrica por linha (nome à esquerda, total à direita).
 */

import { memo } from 'react'
import Icon from './icons.jsx'
import { METRIC_FILTERS } from '../lib/metricFilters.js'

const brl = (v) => `R$ ${v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

function formatValue(key, value) {
  if (typeof value !== 'number' || Number.isNaN(value)) return '—'
  return key === 'investment' ? brl(value) : Math.round(value).toLocaleString('pt-BR')
}

function MetricCards({ active, onChange, values = {}, disabled = false, items, inline = false, list: asList = false }) {
  const list = items || METRIC_FILTERS
  return (
    <div className={`mc-rail${inline ? ' is-inline' : ''}${asList ? ' is-list' : ''}`} role="radiogroup" aria-label="Métrica do mapa">
      {list.map((m) => {
        const isActive = m.key === active
        return (
          <button
            key={m.key}
            type="button"
            role="radio"
            aria-checked={isActive}
            disabled={disabled}
            className={`mc-card${isActive ? ' is-active' : ''}`}
            onClick={() => onChange?.(m.key)}
          >
            <span className="mc-label">
              <Icon n={m.icon} s={12} />
              {m.label}
            </span>
            <span className="mc-value">{formatValue(m.key, values[m.key])}</span>
          </button>
        )
      })}
    </div>
  )
}

export default memo(MetricCards)
